import { IStackTokens, ITextStyles, Stack, Text, ThemeProvider } from "@fluentui/react";
import DefaultBanner from "components/DefaultBanner";
import { CollectionFilter } from "types/stac";
import { CatalogFilter } from "./Catalog.Filter";

import { useTheme } from "@fluentui/react";
import { lightFilterTheme } from "theme";

interface CatalogBannerProps {
  filter: CollectionFilter;
  onFilterChange: any //(new_value: any, field: string)=> void;
}

export const CatalogBanner: React.FC<CatalogBannerProps> = ({
  filter,
  onFilterChange
}) => {
  const theme = useTheme()

  return (
    <DefaultBanner>
      <h1>DestinE Data Portfolio</h1>
      <Stack tokens={bannerTokens}>
        <Text block as={"p"} styles={blurbStyles} style={{ color: theme.palette.white }}>
          The DestinE data lake federates with existing data holdings as well as with complementary data from diverse sources like in-situ, socio-economic, or data-space data.
        </Text>
        <ThemeProvider theme={lightFilterTheme}>
          <CatalogFilter filter={filter} onFilterChange={onFilterChange} advanced />
        </ThemeProvider>
      </Stack>
    </DefaultBanner>

  );
};

const bannerTokens: IStackTokens = {
  childrenGap: 20,
};

const blurbStyles: ITextStyles = {
  root: {
    fontWeight: 500,
  },
};
